export const PHONE_NUMBER = `1-866-EUFLEX1 (383-5391)`;
export const FAX_NUMBER = `1-866-EUFLEX2 (383-5392)`;
